import { ItemStateHandler } from "./ItemStateHandler";
import { IS } from "@green24/npm-javascript-utils";

const reducer = (actionPrefix, {initialState, editOnly, customReducer} = {}) => {
	const handler = new ItemStateHandler({
		actionPrefix,
		initialState,
		editOnly,
	});

	return (state, action) => {
		if(IS.fnc(customReducer)) {
			const reducerResult = customReducer(state, action);
			if(reducerResult) return reducerResult;
		}

		handler.setState(state);

		return handler.handleAction(action);
	}
};

Object.defineProperty(reducer, "initialState", {value: ItemStateHandler.model.defaultInitialState});

export default reducer;
